import { SvgIcon, SvgIconProps } from '@mui/material';

export const TendencyStableIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 12 3" {...props}>
      <rect width="12" height="3" rx="1" fill="inherit" />
    </SvgIcon>
  );
};
